module.exports = __webpack_public_path__ + "7ac7b76f44e641102fc6bfb6b6e75fd3.svg";